"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require('./tag-cloud.module'));
__export(require('./tag-cloud.component'));
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/angular-tag-cloud-module/dist/index.js
 ** module id = 918
 ** module chunks = 0
 **/